import React, { useContext } from "react";
import {
  THEME_UPDATE_MESSAGE,
  TestimonialTheme,
  TestimonialThemeResetOne,
  TestimonialThemeResetTwo,
  TestimonialThemeThreeSet,
  ThemeNo,
} from "../../../../constant";
import TestimonialMultipageContext from "../../../context/TestimonialMultipageContext/TestimonialMultipageContext";
import TestimonialTheme1 from "./TestimonialTheme1";
import TestimonialTheme2 from "./TestimonialTheme2";
import { Button, Col, Container, Row } from "reactstrap";
import { TostMessage } from "../../../utils";
import { putUpdateTestimonial } from "../apis/TestimonialApi/TestimonialApi";
import LoaderContext from "../../../../context/LoaderContext/LoaderContext";
import TestimonialImgTheme1 from "../ScreenShorts/Testimonial/TestimonialTheme1.png";
import TestimonialImgTheme2 from "../ScreenShorts/Testimonial/TestimonialTheme2.png";
import TestimonialImgTheme3 from "../ScreenShorts/Testimonial/TestimonialTheme3.png";
import ThemeImageShow from "../../../common/ThemeImageShow";

const SettingTestimonialPerentPopup = (props) => {
  const { imageUpload, handleSubmitSetting, handleChangeSettings } = props;
  const { theme, setSettingFormData, setTheme, id, imgShow, setImgShow } =
    useContext(TestimonialMultipageContext);
  const { setLoaderShow } = useContext(LoaderContext);

  const resetHandler = () => {
    let setStyle = {};
    if (theme === ThemeNo.ThemeOne) {
      setStyle = TestimonialThemeResetOne;
    } else if (theme === ThemeNo.ThemeTwo) {
      setStyle = TestimonialThemeResetTwo;
    } else if (theme === ThemeNo.ThemeThree) {
      setStyle = TestimonialThemeThreeSet;
    }
    setSettingFormData({ ...setStyle });
  };

  const handleTheme = async (e) => {
    setLoaderShow(true);
    const { value } = e.target;
    setTheme(value);
    try {
      let formData = {
        theme: value,
        testimonialId: id,
      };
      const { data } = await putUpdateTestimonial(formData);
      if (data.status === 200) {
        await handleChangeSettings(id, true);
        TostMessage({
          message: { message: THEME_UPDATE_MESSAGE },
          type: "success",
        });
      }
    } catch (error) {
      TostMessage({ message: error, type: "error" });
    } finally {
      setLoaderShow(false);
    }
  };

  const handleClose = () => {
    setImgShow(false);
  };
  const themeImg = {
    1: TestimonialImgTheme1,
    2: TestimonialImgTheme2,
    3: TestimonialImgTheme3,
  };

  return (
    <>
      <Container className="mb-5">
        <Row>
          <Col sm="12" xl="12">
            <div className="mt-4 d-flex flex-column justify-content-center position-relative">
              <div
                className="d-flex justify-content-between position-sticky"
                style={{ top: "87px", background: "white", zIndex: 999 }}
              >
                <h6>{"Edit"}</h6>
                <div className="d-flex gap-2">
                  <Button onClick={resetHandler}>Reset</Button>
                  <Button onClick={() => handleSubmitSetting(true)}>
                    Restore
                  </Button>
                  <Button
                    onClick={() => handleSubmitSetting(null, false)}
                    color="success"
                  >
                    Save & View
                  </Button>
                </div>
              </div>

              <Row>
                <Col>
                  <label htmlFor="">Theme</label>
                  <select
                    name="theme"
                    id="font-weight"
                    className="form-select"
                    value={theme}
                    onChange={(e) => handleTheme(e)}
                    style={{ borderRadius: "0", color: "black" }}
                  >
                    <option value={1}>Theme 1</option>
                    <option value={2}>Theme 2</option>
                    <option value={3}>Theme 3</option>
                  </select>
                </Col>
              </Row>
              {!imgShow && (
                <div>
                  <Button
                    onClick={() => setImgShow(true)}
                    color="primary"
                    className="mt-2"
                  >
                    Show Theme Image
                  </Button>
                </div>
              )}
              {imgShow && (
                <ThemeImageShow
                  themeImg={themeImg[theme]}
                  handleClose={handleClose}
                />
              )}
              {+theme === TestimonialTheme.theme1 && (
                <TestimonialTheme1
                  imageUpload={imageUpload}
                  handleSubmitSetting={handleSubmitSetting}
                />
              )}
              {+theme === TestimonialTheme.theme2 && (
                <TestimonialTheme1
                  imageUpload={imageUpload}
                  handleSubmitSetting={handleSubmitSetting}
                />
              )}
              {+theme === TestimonialTheme.theme3 && (
                <TestimonialTheme2
                  imageUpload={imageUpload}
                  handleSubmitSetting={handleSubmitSetting}
                />
              )}
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default SettingTestimonialPerentPopup;
